import {PropTypes} from "react";
import {PropTypes as SubschemaPropTypes} from "Subschema";

const {customPropType} = SubschemaPropTypes;

export const isomporphic = PropTypes.oneOfType([PropTypes.func]);
export const prefill = PropTypes.oneOfType([PropTypes.object, PropTypes.string]);
export const munge = PropTypes.oneOfType([PropTypes.object, PropTypes.string]);
export const defaultValue = customPropType(PropTypes.any, 'defaultValue');
export const notif = customPropType(PropTypes.any, 'notif');

export const requestTracking = PropTypes.shape({
    page: PropTypes.string,
    pageGroup: PropTypes.string
});

export const griffinAddress = PropTypes.shape({
    strings: PropTypes.object,
    layout: PropTypes.arrayOf(PropTypes.string)
});

export const pageInfo = PropTypes.shape({
    rLogId: PropTypes.string,
    fptiPgrp: PropTypes.string,
    hostName: PropTypes.string
});

export default ({
    requestTracking,
    prefill,
    munge,
    griffinAddress,
    isomporphic,
    defaultValue,
    notif,
    pageInfo
})



/** WEBPACK FOOTER **
 ** ./src/PropTypes.js
 **/